import { useEffect, useState } from 'react';
import { InternetConnectionStatus, InternetConnectionType } from '@connect-x-app/shared-types';

export const useInternetConnection = (): InternetConnectionType => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    internetConnectionStatus: isOnline ? InternetConnectionStatus.ONLINE : InternetConnectionStatus.OFFLINE,
    isInternetConnectionOffline: !isOnline,
    isInternetConnectionOnline: isOnline,
  };
};
